<div class="support-login-container">
  <div *ngIf="isLoading" class="loading-state">
    <div class="loading-wrapper">
      <div class="bar-chart">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <div class="loading-text">{{ currentMessage }}</div>
    </div>
  </div>
  <div *ngIf="isSignInErroredOut && !isLoading" class="error-state">
    <div class="error-wrapper">
      <lib-error-state
        [subtext]="errorMessage"
        [buttonLabel]="'Return to admin portal'"
        [buttonIcon]="icon"
        (buttonClick)="redirectToAdminPortal()"
      />
    </div>
  </div>
</div>
